import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';

/**
 * DeleteSessionDialog component
 * Confirmation dialog for deleting a chat session
 */
const DeleteSessionDialog = ({ sessionToDelete, setSessionToDelete, deleteSession }) => {
  return (
    <AlertDialog open={!!sessionToDelete} onOpenChange={(open) => !open && setSessionToDelete(null)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Eliminar esta conversación de tu vista?</AlertDialogTitle>
          <AlertDialogDescription>
            Dejará de mostrarse en tu historial. Por motivos de seguridad y
            cumplimiento legal, la conversación se conserva en el servidor y no se
            elimina de forma permanente (ver{' '}
            <a
              href="/legal/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-sky-600 dark:text-sky-400"
            >
              Términos y Condiciones
            </a>
            ).
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={deleteSession}
            className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
          >
            Eliminar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteSessionDialog;
